import React from 'react';
import {Helmet} from 'react-helmet';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const About=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.aboutPageTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar 
        globalSettings={globalSettings}
      />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='text-center mb-10'>
            <h1 className='text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
              {locales.aboutHeadingPrefix[globalSettings.lang]}
              <span className='text-purple-800'>
                {locales.aboutHeadingHighlight[globalSettings.lang]}
              </span>
              {locales.aboutHeadingSuffix[globalSettings.lang]}
            </h1>
            <p className='mt-4 text-xl text-gray-600'>
              {locales.aboutMission[globalSettings.lang]}
            </p>
          </div>
          <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
            <div className='text-center'>
              <h2 className='text-2xl font-bold text-gray-900 mb-6'>
                {locales.aboutUsHeading[globalSettings.lang]}
              </h2>
              <p className='text-gray-600 text-lg leading-relaxed'>
                {locales.aboutDescription[globalSettings.lang]}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer 
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default About;

